<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" xl="1" lg="1" md="1" sm="1">
                <v-btn x-large height="56" class="font-size-20 white--text" @click="prevPage" color="blue-grey lighten-3">< 戻る</v-btn>
           </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="text-center">
                <v-menu v-model="openMenu" left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="font-size-20 white--text" width="200" height="56" color="blue-grey" x-large offset-x>
                            <v-icon left>mdi-cloud-download-outline</v-icon>
                            ダウンロード
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item :href="fileDownloadBtnUrl">
                            <v-list-item-title class="font-size-20">契約文書</v-list-item-title>
                        </v-list-item>
                        <v-list-item link v-if="agreement.contract_status == 3" :href="'/documents/document-management/download-consensus-sign/' + agreement.id">
                            <v-list-item-title class="font-size-20">合意締結証明書</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3">
                <label-component fontSize="30" fontWeight="bold">契約情報詳細</label-component>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3"></v-col>
        </v-row>
        <v-row>
            <v-col cols="7">
                <v-card flat>
                    <v-container>
                        <v-row>
                            <v-tabs
                                v-model="fileTab"
                                dark
                                background-color="grey"
                                show-arrows
                            >
                                <v-tabs-slider ></v-tabs-slider>
                                <v-tab
                                    active-class="white"
                                    v-for="(pdfObj, index) in Object.entries(this.pdfs)"
                                    :key="pdfObj[0]"
                                    :disabled="pdfLoading"
                                >
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span
                                            class="info-to"
                                            v-bind="attrs"
                                            v-on="on"
                                            >
                                                {{ pdfObj[1].filename | omittedText }}
                                            </span>
                                        </template>
                                        <span>{{ pdfObj[1].filename }}</span>
                                    </v-tooltip>
                                </v-tab>
                            </v-tabs>
                            <pdf-document-component
                                v-for="(pdfObj, index) in Object.entries(this.pdfs)"
                                :key="pdfObj[0]"
                                v-show="currentPdfId==pdfObj[0]"
                                scale="autoWidth"
                                :url="baseUrl+pdfObj[0]"
                                :pdfId="pdfObj[0]"
                                @loading="loading"
                                />
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
            <v-col cols="5">
                <v-card flat>
                    <v-container>
                        <v-row>
                            <v-col cols="12" xl="3">
                                <label-component>タイトル</label-component>
                            </v-col>
                            <v-col cols="12" xl="9">
                                <label-component>{{ item.title }}</label-component>
                            </v-col>
                        </v-row>
                        <validation-observer ref="obs" v-slot="{ invalid }">
                            <validation-provider name="管理番号" rules="max:255"  v-slot="{ errors }">
                                <v-row class="my-1">
                                    <v-col cols="12" xl="4" class="py-0">
                                        <badge-component color="grey darken-1" content="?" enableClick>
                                            <badge-component tile content="任　意"><label-component>管理番号</label-component></badge-component>
                                        </badge-component>
                                    </v-col>
                                    <v-col cols="12" xl="8" class="py-0">
                                        <v-text-field :readonly="readonly" v-model="item.manageNo" outlined placeholder="例） 000-000-0000、MA100000など" :counter="255" :error-messages="errors" :clearable="!readonly" v-disabled-icon-focus background-color="white"></v-text-field>
                                    </v-col>
                                </v-row>
                            </validation-provider>
                            <validation-provider name="管理用タイトル" rules="max:255" v-slot="{ errors }">
                                <v-row class="my-1">
                                    <v-col cols="12" xl="4" class="py-0">
                                        <badge-component color="grey darken-1" content="?" enableClick>
                                            <badge-component tile content="任　意" ><label-component>管理用タイトル</label-component></badge-component>
                                        </badge-component>
                                    </v-col>
                                    <v-col cols="12" xl="8" class="py-0">
                                        <v-text-field :readonly="readonly" v-model="item.manageTitle" placeholder="管理用にタイトルを入力してください" :counter="255" :error-messages="errors" outlined :clearable="!readonly" v-disabled-icon-focus background-color="white"></v-text-field>
                                    </v-col>
                                </v-row>
                            </validation-provider>
                            <validation-provider name="memo" rules="max:10000" v-slot="{ errors }">
                                <v-row class="my-1">
                                    <v-col cols="12" xl="4" class="py-0">
                                        <badge-component tile content="任　意"><label-component>取引先</label-component></badge-component>
                                    </v-col>
                                    <v-col cols="12" xl="8" class="py-0">
                                        <v-textarea :readonly="readonly" :clearable="!readonly" :counter="10000" auto-grow outlined v-disabled-icon-focus rows="3" placeholder="取引先の会社名などを入力してください" :error-messages="errors" v-model="item.memo" background-color="white"></v-textarea>
                                    </v-col>
                                </v-row>
                            </validation-provider>
                            <v-row class="my-1">
                                <v-col cols="12" xl="4" class="py-0">
                                    <badge-component color="grey darken-1" content="?" enableClick>
                                        <badge-component tile content="任　意"><label-component>契約締結日</label-component></badge-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="8" class="py-0">
                                    <date-picker-component :readonly="readonly" v-model="item.contractDate"/>
                                </v-col>
                            </v-row>
                            <v-row class="my-1">
                                <v-col cols="12" xl="4" class="py-0">
                                    <badge-component tile content="任　意"><label-component>契約開始日</label-component></badge-component>
                                </v-col>
                                <v-col cols="12" xl="8" class="py-0">
                                    <date-picker-component :readonly="readonly" v-model="item.startDate"/>
                                </v-col>
                            </v-row>
                            <v-row class="my-1">
                                <v-col cols="12" xl="4" class="py-0">
                                    <badge-component color="grey darken-1" content="?" enableClick>
                                        <badge-component tile content="任　意"><label-component>契約終了日</label-component></badge-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="8" class="py-0">
                                    <date-picker-component :readonly="readonly" v-model="item.endDate"/>
                                </v-col>
                            </v-row>
                            <v-row class="my-1">
                                <v-col cols="12" xl="4" class="py-0">
                                    <badge-component tile content="任　意"><label-component>自動更新の有無</label-component></badge-component>
                                </v-col>
                                <v-col cols="12" xl="8" class="py-0">
                                    <v-select
                                        v-model="select.updateValue"
                                        :items="select.updates"
                                        outlined
                                        :readonly="readonly"
                                        background-color="white"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row class="my-1">
                                <v-col cols="12" xl="4" class="py-0">
                                    <badge-component color="grey darken-1" content="?" enableClick>
                                        <badge-component tile content="任　意"><label-component>解約通知期限</label-component></badge-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="8" class="py-0">
                                    <date-picker-component :readonly="readonly" v-model="item.cancelNoticeDeadlineDate"/>
                                </v-col>
                            </v-row>
                            <validation-provider name="取引金額" rules="integer" v-slot="{ errors }">
                                <v-row class="my-1">
                                    <v-col cols="12" xl="4" class="py-0">
                                        <badge-component tile content="任　意"><label-component>取引金額</label-component></badge-component>
                                    </v-col>
                                    <v-col cols="12" xl="8" class="py-0">
                                        <v-text-field :readonly="readonly" v-model="item.amount" outlined type="number" min="0" placeholder="40000" :error-messages="errors" :clearable="!readonly" v-disabled-icon-focus background-color="white"></v-text-field>
                                    </v-col>
                                </v-row>
                            </validation-provider>
                            <span v-for="(userItem, index) in userItems">
                                <validation-provider name="userItem['item_name']" :rules="{required:userItem['is_required'] == 1, max:255}" v-slot="{ errors }">
                                    <v-row class="my-1">
                                        <v-col cols="12" xl="4" class="py-0">
                                            <badge-component tile :content="userItem['is_required'] == 1 ? '必　須' : '任　意'"><label-component>{{ userItem['item_name'] }}</label-component></badge-component>
                                        </v-col>
                                        <v-col cols="12" xl="8" class="py-0">
                                            <v-text-field :readonly="readonly" v-model="userItem['value']" outlined placeholder="社内の運用に併せて値を設定してください" :error-messages="errors" :clearable="!readonly" v-disabled-icon-focus background-color="white"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </validation-provider>
                            </span>
                            <v-row justify="center" v-if="!readonly">
                                <v-col cols="12" class="text-center">
                                    <button-component @click="clickOk" color="red" :disabled="invalid || disabledBtn">保存</button-component>
                                </v-col>
                            </v-row>
                        </validation-observer>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
        <!-- メッセージ -->
        <message-component id="message" v-model="isMessage" :success="message.success">{{ message.text }}</message-component>
    </v-container>
</template>
<script>
    import {setTimeoutCheckLogin} from '../../common/loginUtil.js';
    
    const NO_SETTING = 1;
    const WITH_SETTINGS = 2;

    export default {
        props: {
            id: Number,
            agreement: Object,
            userDefinedItems: Array,
            isEdit: Boolean,
            pdfs: Object,
        },
        data() {
            return {
                fileUrl: null,
                baseUrl: '/documents/document-management/get-contract/',
                item: {
                    title: null,
                    manageTitle: null,
                    memo: null,
                    contractDate: null,
                    startDate: null,
                    automatic_updating: 0,
                    endDate: null,
                    cancelNoticeDeadlineDate: null,
                    manageNo: null,
                    amount: null,
                    automaticUpdating: null,
                },
                // ユーザー定義項目
                userItems: [],
                select: {
                    updateValue: NO_SETTING,
                    updates: [
                        { text: '' , value: 0 } ,
                        { text: '設定無し' , value: NO_SETTING } ,
                        { text: '設定有り' , value: WITH_SETTINGS } ,
                    ],
                    fileValue: null
                },
                // ボタン無効化(trueなら無効化)
                disabledBtn: false,
                // 参照権限
                readonly: false,
                // 更新権限
                edit: false,
                message: {
                    success: false,
                    text: "",
                },
                pdfLoading: false,
                currentPdfId: 0,
                fileTab: 0,
                openMenu: false,
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
            fileDownloadBtnUrl: function(){
                return this.fileUrl + '?download_type=btn';
            }
        },
        filters: {
            omittedText(text) {
             // 11文字目以降は"…"
             return text.length > 10 ? text.slice(0, 10) + "…" : text;
            },
        },
        created: function () {
            setTimeoutCheckLogin();
            
            // 更新権限がない場合は参照のみ
            this.readonly = !this.isEdit;
            
            this.currentPdfId = Object.entries(this.pdfs)[0][0];
            // pdfの取得URL
            this.fileUrl = this.baseUrl + Object.entries(this.pdfs)[0][0];
            
            // 初期値をセット
            this.item.title = this.agreement.contract_name;
            
            if (this.agreement.contracts[0].contract_informations[0]) {
                // 契約情報詳細
                this.item.manageTitle = this.agreement.contracts[0].contract_informations[0]['control_title'];
                this.item.manageNo = this.agreement.contracts[0].contract_informations[0]['control_number'];
                this.item.memo = this.agreement.contracts[0].contract_informations[0]['memo'];
                this.item.contractDate = this.agreement.contracts[0].contract_informations[0]['contract_date'];
                this.item.startDate = this.agreement.contracts[0].contract_informations[0]['contract_start_date'];
                this.item.endDate = this.agreement.contracts[0].contract_informations[0]['contract_end_date'];
                this.item.cancelNoticeDeadlineDate = this.agreement.contracts[0].contract_informations[0]['cancellation_notice_deadline'];
                this.select.updateValue = this.agreement.contracts[0].contract_informations[0]['is_automatic_updating'];
                this.item.amount = this.agreement.contracts[0].contract_informations[0]['transaction_amount'];
            }

            // ユーザー定義項目
            for (let i = 0; i < this.userDefinedItems.length; i++) {
                if (this.userDefinedItems[i]['is_required'] != 0) {
                    let val = null;
                    if (this.userDefinedItems[i]['contract_user_defined_items'][0]) {
                        val = this.userDefinedItems[i]['contract_user_defined_items'][0]['value'];
                    }
                    this.userItems.push({item_name: this.userDefinedItems[i]['item_name'], is_required: this.userDefinedItems[i]['is_required'], value: val});
                }
            }
        },
        methods: {
            // 遷移元に戻る
            prevPage() {
                // リファラで判断する方法だと、2つ前の画面の判断や、概要→詳細→概要→戻るボタン押下の時に問題が出るため
                history.back();
            },
            clickOk() {
                this.disabledBtn = true,
                this.item.automaticUpdating = this.select.updateValue;
                
                var self = this;
                window.axios.post('/documents/document-management/save/' + this.id, {
                    item: self.item,
                    user_items: self.userItems,
                }).then(res => {
                    if (res.data.success) {
                        self.message.text = res.data.message;
                        self.message.success = true;
                    } else {
                        self.message.text = res.data.message;
                        self.message.success = false;
                    }
                }).catch(err => {
                    self.message.success = false;
                    if (err.data != null && err.data.message != null && err.data.message != '') {
                        self.message.text = err.data.message;
                    } else {
                        self.message.text = '契約情報の更新に失敗しました';
                    }
                }).finally(() => {
                    self.disabledBtn = false;
                });
            },
            loading: function (isLoading) {
                this.pdfLoading = isLoading;
            },
        }
    };
</script>

<style scoped>
    .item-td {
        cursor: pointer
    }
</style>